import axios from "axios";
import { ACCOUNT_SERVICE_URL } from "../config";

const api = axios.create({
  baseURL: ACCOUNT_SERVICE_URL,
});

// Request deduplication for authorize calls
let authorizePromise = null;

export async function login(email, password, newPassword = null) {
  try {
    const { data } = await api.post(
      "/auth/login",
      { email, password, ...(newPassword && { newPassword }) },
      { withCredentials: true }
    );
    return data;
  } catch (error) {
    console.error('Login error:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(error.message || 'Login failed');
  }
}

export async function logout() {
  try {
    await api.post("/auth/logout", {}, { withCredentials: true });
  } catch (e) {
    console.warn("Logout request failed", e);
    // Don't throw error for logout failures
  }
}

export async function forgotPassword(email) {
  try {
    const { data } = await api.post("/auth/forgot-password", { email });
    return data;
  } catch (error) {
    console.error('Forgot password error:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(error.message || 'Forgot password failed');
  }
}

export async function resetPassword(email, code, password) {
  try {
    const { data } = await api.post("/auth/reset-password", { email, code, password });
    return data;
  } catch (error) {
    console.error('Reset password error:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(error.message || 'Reset password failed');
  }
}

export async function changePassword(oldPassword, newPassword) {
  try {
    const { data } = await api.post("/auth/change-password", { oldPassword, newPassword }, { withCredentials: true });
    return data;
  } catch (error) {
    console.error('Change password error:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(error.message || 'Change password failed');
  }
}

export async function authorize() {
  // If there's already an authorize request in progress, return the same promise
  if (authorizePromise) {
    return authorizePromise;
  }
  
  // Create new promise for this authorize request
  authorizePromise = api.get("/auth/me", { withCredentials: true })
    .then(({ data }) => {
      authorizePromise = null; // Clear the promise when done
      return data;
    })
    .catch((error) => {
      authorizePromise = null; // Clear the promise on error
      console.error('Authorize error:', error);
      if (error.response?.status === 401) {
        // User is not authenticated, this is expected
        throw new Error('Not authenticated');
      }
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error(error.message || 'Authorization failed');
    });
  
  return authorizePromise;
}
